import React, { useState, useEffect, useRef } from 'react';
import { useSelector} from 'react-redux';
import ManageDisbursmentHeader from '../../components/Disbursment/ManageDisbursmentHeader'
import BeneficiaryReimbursementList from '../../components/BeneficiaryReimbursement/BeneficiaryReimbursementList';
import {Tab, Tabs} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import CreateButton from '../../components/Tools/CreateButton';

export default function BeneficiaryReimbursementListPage() {
    const navigate = useNavigate();
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('reimbursement_order_date');
    const [searchStr, setToSearchStr] = useState('');
    const [page, setPage] = useState('approve');
    const {listType} = useParams();
    const [heading, setHeading] = useState('');
    const [departmentId, setDepartmentId] = useState('');
    const [title, setTitle] = useState('');


    const defaultSelection = () => {
        if(listType === 'approval') {
            setTitle("DBT/Nach Approval")
        } else if(listType === 'payment') {
            setTitle("DBT/Nach Payment")
        } else {
            setTitle("DBT/Nach");
        }
    }
    useEffect(() => {
        defaultSelection();
    }, [listType])

    const handleDateChange = (start, end, dateColumn, searchStr, fyId, tier, departmentId) => {
        setFromDate(start);
        setToDate(end);
        setDateColumn(dateColumn);
        setToSearchStr(searchStr);
        setDepartmentId(departmentId);

    };
    const handleTabSelect = (key) => {
        if (key == 'approve') {
            setHeading("Approval");
            setPage("approve");
            navigate('/beneficiary-reimbursement/approval');
        } else if(key == 'payment') {
            setHeading("Payment");
            setPage("payment");
            navigate('/beneficiary-reimbursement/payment');
        } else if(key == 'dbt_payment') {
            setHeading("DBT/Bulk/NACH Payments");
            setPage("dbt_payment");
            navigate('/beneficiary-reimbursement/dbt_payment');
        }
    };

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>{title}</h4>
                        <CustomBreadcrumbs linksArray={[]} title={title}/>
                    </div>
                    <div className="col-md-6">
                        {
                            title === "DBT/Nach Approval" && <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                                <button type="button" className="navigation_button" onClick={() => navigate("/beneficiary-reimbursement/payment")}>
                                    <span className="fs-14px">DBT/Nach Payment</span>
                                </button>
                            </div> 
                        }
                        {  
                            title === "DBT/Nach Payment" &&  <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                                <button type="button" className="navigation_button" onClick={() => navigate("/beneficiary-reimbursement/approval")}>
                                    <span className="fs-14px">DBT/Nach Approval</span>
                                </button>
                            </div>
                        }
                        
                    </div>
                </div>
                <BeneficiaryReimbursementList fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr} departmentId={departmentId} />
            </div>

            {
                !listType && authData.user.user_type === 'l1' && (
                    <CreateButton title={"Add DBT/Nach"} url={"/add-beneficiary-reimbursement"}/>
                )
            }
        </div>
    )
}